import React from 'react';

export interface ProofreadSettings {
  spelling: boolean;
  grammar: boolean;
  activeVoice: boolean;
  conciseness: boolean;
  sentenceSplit: boolean;
}

interface ProofreadModalProps {
  /** Passed in from the editor, which is where the language hook lives */
  t: any;
  show: boolean;
  onClose: () => void;
  settings: ProofreadSettings;
  onUpdateSettings: (settings: ProofreadSettings) => void;
}

export const ProofreadModal: React.FC<ProofreadModalProps> = ({
  t,
  show,
  onClose,
  settings,
  onUpdateSettings,
}) => {
  if (!show) return null;

  const handleSettingChange = (key: keyof ProofreadSettings, value: boolean) => {
    onUpdateSettings({
      ...settings,
      [key]: value,
    });
  };

  return (
    <div className="proofread-modal-overlay" onClick={onClose}>
      <div className="proofread-modal" onClick={(e) => e.stopPropagation()}>
        <div className="proofread-modal-header">
          <h3>{t.editor.proofreadSettings}</h3>
          <button 
            className="proofread-close-btn"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        <div className="proofread-options">
          <p className="proofread-description">
            {t.editor.proofreadIntro}
          </p>
          
          <label className="proofread-checkbox">
            <input
              type="checkbox"
              checked={settings.spelling}
              onChange={(e) => handleSettingChange('spelling', e.target.checked)}
            />
            <div className="proofread-option-content">
              <span className="proofread-option-name">{t.editor.proofSpelling}</span>
              <span className="proofread-option-desc">{t.editor.proofSpellingDesc}</span>
            </div>
          </label>

          <label className="proofread-checkbox">
            <input
              type="checkbox"
              checked={settings.grammar}
              onChange={(e) => handleSettingChange('grammar', e.target.checked)}
            />
            <div className="proofread-option-content">
              <span className="proofread-option-name">{t.editor.proofGrammar}</span>
              <span className="proofread-option-desc">{t.editor.proofGrammarDesc}</span>
            </div>
          </label>

          <label className="proofread-checkbox">
            <input
              type="checkbox"
              checked={settings.activeVoice}
              onChange={(e) => handleSettingChange('activeVoice', e.target.checked)}
            />
            <div className="proofread-option-content">
              <span className="proofread-option-name">{t.editor.proofActiveVoice}</span>
              <span className="proofread-option-desc">{t.editor.proofActiveVoiceDesc}</span>
            </div>
          </label>

          <label className="proofread-checkbox">
            <input
              type="checkbox"
              checked={settings.conciseness}
              onChange={(e) => handleSettingChange('conciseness', e.target.checked)}
            />
            <div className="proofread-option-content">
              <span className="proofread-option-name">{t.editor.proofConciseness}</span>
              <span className="proofread-option-desc">{t.editor.proofConcisenessDesc}</span>
            </div>
          </label>

          <label className="proofread-checkbox">
            <input
              type="checkbox"
              checked={settings.sentenceSplit}
              onChange={(e) => handleSettingChange('sentenceSplit', e.target.checked)}
            />
            <div className="proofread-option-content">
              <span className="proofread-option-name">{t.editor.proofSentenceSplit}</span>
              <span className="proofread-option-desc">{t.editor.proofSentenceSplitDesc}</span>
            </div>
          </label>
        </div>

        <div className="proofread-note">
          <p><strong>{t.editor.noteLabel}</strong> {t.editor.proofreadNote}</p>
        </div>
      </div>
    </div>
  );
};
